import {
    Box,
    Center,
    Divider,
    Heading,
    HStack,
    SimpleGrid,
    Link,
    Text,
    Container,
    Button,
    Stat,
    StatLabel,
    StatNumber,
    useColorModeValue
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { merge, tap } from "rxjs";
import Web3Service from "../core/web3.service";

import NFTItemView from "./NFTItemView";

interface CollectionViewProps { }

const CollectionView: React.FC<CollectionViewProps> = (props) => {
    const web3Service = Web3Service.shared();

    const [account, setAccount] = useState<string | undefined>(undefined);
    const [tokens, setTokens] = useState<number[]>([]);

    useEffect(() => {
        web3Service.getTokens()

        const account$ = web3Service.account$.pipe(
            tap((account) => {
                setAccount(account);
            })
        );

        const tokens$ = web3Service.tokens$.pipe(
            tap((tokens) => {
                setTokens(tokens);
            })
        );

        const subscription = merge(
            tokens$,
            account$
        ).subscribe();

        return () => {
            subscription.unsubscribe();
        };
    }, [account]);

    let content = <>
        <SimpleGrid
            textColor={'rgb(55, 55, 128)'}
            columns={{ base: 1, md: 2 }}
            spacing={{ base: 4, md: 8 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            px={{base: 4, md: 0}}
        >
            <Stat
                bg={'white'}
                rounded={"xl"}
                css={{
                    border: '2px solid rgb(55, 55, 128)',
                }}
                boxShadow={"0 6px 0px 0 #373780"}
                p={4}>
                <StatLabel>Address</StatLabel>
                <StatNumber fontSize={{ base: 'sm', md: 'md' }}>{account}</StatNumber>
            </Stat>

            <Stat
                rounded={"xl"}
                bg={'white'}
                css={{
                    border: '2px solid rgb(55, 55, 128)',
                }}
                boxShadow={"0 6px 0px 0 #373780"}
                p={4}>
                <StatLabel>Owned Noodles</StatLabel>
                <StatNumber fontSize={{ base: 'sm', md: 'md' }}>{tokens.length} Noodles</StatNumber>
            </Stat>
        </SimpleGrid>

        <SimpleGrid
            columns={{ base: 2, md: 4 }}
            spacing={{ base: 4, md: 8 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            maxW={"4xl"}
        >
            {tokens.map((token, i) => (
                <Link key={i} href={`https://bafybeibnvd6akht62krize4orcwtrwaterhwgybfymdh4punc3dlknuqsu.ipfs.nftstorage.link/${token}.png`} isExternal>
                    <NFTItemView
                        name={`#${token}`}
                        image={`https://bafybeibnvd6akht62krize4orcwtrwaterhwgybfymdh4punc3dlknuqsu.ipfs.nftstorage.link/${token}.png`}
                    />
                </Link>
            ))}
        </SimpleGrid>
    </>

    let emptyView = <>
        <Center mt={8}>
            <Text maxW={'2xl'}>You do not own any Noodles currently</Text>
        </Center>
    </>

    let connectWallet = <>
        <Container>
            <Center mt={8}>
                <Text maxW={'2xl'}>Connect Wallet to see the Noodles you own</Text>
            </Center>
            <Center mt={8}>
                <Button size={{ base: 'sm', sm: 'sm', md: 'md' }} onClick={web3Service.toggleConnect}>
                    {"Connect Wallet"}
                </Button>
            </Center>
        </Container>
    </>

    return (
        <>
            <Center my={8}>
                <Box>
                    {account ? (tokens.length > 0 ? content : emptyView) : connectWallet}
                </Box>
            </Center>
        </>
    );
};

export default CollectionView;
